import SearchIcon from '@mui/icons-material/Search';

// core components
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import Chip from '@mui/material/Chip';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';

import { ThemedCheckbox, ThemedInput } from '@themes/defaultThemeProps';
import Datetime from 'react-datetime';
import { useHistory } from 'react-router-dom';

const SearchCriteria = ({
  classes,
  handleChangeCalendar,
  handleChange,
  filters,
  enabled,
  locations,
  workstations,
  applications,
  levels,
  messages,
  handleSubmitForm,
  setSendButton,
  tenant,
  client,
  ntAdministration,
  setFilters,
}) => {
  const history = useHistory();
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 224,
        width: 350,
      },
    },
  };

  const getDefaultApplication = () => {
    return filters.applicationTypes.includes('client') ||
      filters.applicationTypes.length == 0
      ? 'client'
      : filters.applicationTypes.includes('server')
      ? 'server'
      : 'portal';
  };

  const handleClickSubmit = (e) => {
    setSendButton(true);
    setFilters((prev) => ({
      ...prev,
      ['activeApplication']: getDefaultApplication(),
    }));

    handleSubmitForm();
  };

  return (
    (<GridItem xs={12} sm={12} md={12}>
      <Card>
        <CardHeader color='rose' icon>
          <CardIcon color='primary'>
            <SearchIcon />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Search Criteria</h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            {/* Application Logs */}
            <GridItem xs={4}>
              <FormControl variant="standard" className={classes.chipContainer}>
                <InputLabel
                  id='applicationTypes-select-label'
                  className={classes.inputLabel}
                >
                  Application Logs
                </InputLabel>
                <Select
                  variant="standard"
                  className={classes.select}
                  labelId='applicationTypes-select-label'
                  id='applicationTypes-select'
                  multiple
                  name='applicationTypes'
                  value={filters.applicationTypes}
                  onChange={handleChange}
                  input={<ThemedInput />}
                  renderValue={(selected) => (
                    <div className={classes.chipContainer}>
                      {selected.map((value) => (
                        <Chip
                          className={classes.chip}
                          key={value}
                          label={value}
                        />
                      ))}
                    </div>
                  )}
                  MenuProps={MenuProps}>
                  {applications.map((application) => (
                    <MenuItem key={application.value} value={application.value}>
                      <ThemedCheckbox
                        checked={filters.applicationTypes.includes(
                          application.value
                        )}
                      />
                      <ListItemText primary={application.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Datetime
                isValidDate={(current) => {
                  return filters.endDate
                    ? current.isBefore(filters.endDate)
                    : true;
                }}
                onChange={(e) => handleChangeCalendar(e, 'startDate')}
                utc={false}
                inputProps={{
                  placeholder: 'Start Date / Time',
                  autoComplete: 'off',
                }}
                renderInput={(props) => (
                  <FormControl variant="standard" style={{ marginTop: '1rem' }} fullWidth={true}>
                    <TextField variant="standard" className={classes.formControl} type='text' {...props} />
                  </FormControl>
                )}
              />
            </GridItem>
            {/* Log Level */}
            <GridItem xs={4}>
              <FormControl variant="standard" className={classes.chipContainer}>
                <InputLabel
                  id='levelTypes-select-label'
                  className={classes.inputLabel}
                >
                  Log Level
                </InputLabel>
                <Select
                  variant="standard"
                  className={classes.select}
                  labelId='levelTypes-select-label'
                  id='levelTypes-select'
                  multiple
                  name='levelTypes'
                  value={filters.levelTypes}
                  onChange={handleChange}
                  input={<ThemedInput />}
                  renderValue={(selected) => (
                    <div className={classes.chipContainer}>
                      {selected.map((value) => (
                        <Chip
                          className={classes.chip}
                          key={value}
                          label={value}
                        />
                      ))}
                    </div>
                  )}
                  MenuProps={MenuProps}>
                  {levels.map((level) => (
                    <MenuItem key={level.value} value={level.value}>
                      <ThemedCheckbox
                        checked={filters.levelTypes.includes(level.value)}
                      />
                      <ListItemText primary={level.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Datetime
                isValidDate={(current) => {
                  return filters.startDate
                    ? current.isAfter(filters.startDate)
                    : true;
                }}
                onChange={(e) => handleChangeCalendar(e, 'endDate')}
                utc={false}
                inputProps={{
                  placeholder: 'End Date / Time',
                  autoComplete: 'off',
                }}
                renderInput={(props) => (
                  <FormControl variant="standard" style={{ marginTop: '1rem' }} fullWidth={true}>
                    <TextField
                      variant="standard"
                      // mt={2}
                      className={classes.formControl}
                      type='text'
                      {...props} />
                  </FormControl>
                )}
              />
            </GridItem>
            {/* Message Types */}
            <GridItem xs={4}>
              <FormControl variant="standard" className={classes.chipContainer}>
                <InputLabel
                  id='messageTypes-select-label'
                  className={classes.inputLabel}
                >
                  Message Types
                </InputLabel>
                <Select
                  variant="standard"
                  className={classes.select}
                  labelId='messageTypes-select-label'
                  id='messageTypes-select'
                  multiple
                  name='messageTypes'
                  value={filters.messageTypes}
                  onChange={handleChange}
                  input={<ThemedInput />}
                  renderValue={(selected) => (
                    <div className={classes.chipContainer}>
                      {selected.map((value) => (
                        <Chip
                          className={classes.chip}
                          key={value}
                          label={value}
                        />
                      ))}
                    </div>
                  )}
                  MenuProps={MenuProps}>
                  <MenuItem key='all' value='all'>
                    <ThemedCheckbox
                      checked={filters.messageTypes.length == messages.length}
                    />
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          variant='body2'
                          style={{ fontWeight: 'bold', fontSize: '16px' }}
                        >
                          Select all
                        </Typography>
                      }
                    />
                  </MenuItem>
                  <Divider />
                  {messages.map((message) => (
                    <MenuItem key={message.value} value={message.value}>
                      <ThemedCheckbox
                        checked={filters.messageTypes.includes(message.value)}
                      />
                      <ListItemText primary={message.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12}>
              <Button
                onClick={handleClickSubmit}
                color='primary'
                className={classes.registerButton}
                disabled={!enabled}
              >
                SEARCH
              </Button>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>)
  );
};
export default SearchCriteria;
